var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-btn',{attrs:{"href":`${_vm.appApi}/v1/auth/facebook?ref=${_vm.url.origin}`}},[_vm._v(" Login con Facebook ")]),_c('br'),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.settings.get('system', 'app', 'uuid')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }